// sekcja demo na stronie głównej

import React, { FC, useEffect } from 'react';

import { useGetCmsSectionArticle, useGetCmsSectionArticles } from 'api';
import { useSelector } from 'store';

import {
  HtmlBlockMultipleArticle,
  HtmlBlockSingleArticle
} from 'components/containers/HtmlBlock/components';

interface IProps {
  sectionId: string;
  articleId?: string;
  isCmsPage?: boolean;
  withBreadCrumbs?: boolean;
  h1?: string | null;
  hasSeoTitle?: boolean;
}

export const HtmlBlock: FC<IProps> = ({ sectionId, articleId, withBreadCrumbs, h1, hasSeoTitle }) => {
  const { profile } = useSelector((state) => state.auth);

  // pobranie bloku html
  const { data: singleArticleData, refetch: refetchSingleData } = useGetCmsSectionArticle(
    sectionId,
    articleId || '',
    {
      enabled: false
    }
  );

  // pobranie bloku html
  const { data: multipleArticleData, refetch: refetchMultipleData } = useGetCmsSectionArticles(
    sectionId,
    { fetchArticleFields: true },
    {
      enabled: false
    }
  );

  useEffect(() => {
    if (articleId) {
      refetchSingleData();

      return;
    }

    refetchMultipleData();
  }, [articleId, sectionId, profile]);

  return (
    <>
      {articleId ? (
        <HtmlBlockSingleArticle content={singleArticleData} withBreadCrumbs={withBreadCrumbs} h1={h1} hasSeoTitle={hasSeoTitle} />
      ) : (
        <HtmlBlockMultipleArticle content={multipleArticleData} />
      )}
    </>
  );
};

export default HtmlBlock;
